import { gateway } from "../../../gateway";

export const removeAdmin = async (uid: string) => {
  const token = sessionStorage.getItem("token");

  const res = await gateway.delete(`/workforce/admin/${encodeURIComponent(uid)}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  return res.data;
};
